<template>
  <thead class="thead-light">
    <tr>
      <th>Activation ID</th>
      <th>Allocated/Total</th>
      <th><abbr title="Fulfilled Count">FC</abbr></th>
      <th><abbr title="Available Reallocation Count">ARC</abbr></th>
      <th>Version Date</th>
      <th>Expiration Date</th>
      <th>Order ID</th>
      <th>AC ID</th>
      <th>Status</th>
    </tr>
  </thead>
</template>

<script>
export default {
  name: 'LicenseCheckerTableHeaders'
}
</script>

<style>
abbr[title] {
  text-decoration: none;
  border-bottom: 1px dotted #202020;
}
</style>


// WEBPACK FOOTER //
// src/components/license-checker/license-checker-table-headers.vue